export default [
  {
    path: "/qspiPerformance",
    component: () =>
      import("@/components/page/QSPI/QSPIReport/qspiPerformance"),
    meta: { title: "Performance 报表" },
  },
  {
    path: "/qspiOverallPerformance",
    component: () => import("@/components/page/QSPI/QSPIReport/qspiOverallPerformance"),
    meta: { title: "Overall Performance 报表" },
  },
  {
    path: "/qspiMonthlyAnalysis",
    component: () =>
      import("@/components/page/QSPI/QSPIReport/qspiMonthlyAnalysis"),
    meta: { title: "Monthly Analysis 报表" },
  },
];
